/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  ApiCreateDemoDto,
  ApiDemoBookedDto,
  ApiDemoQuestionAnswerDto,
  DemoDto,
  DemoQuestionsDto,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiDemoController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-demo-controller
   * @name QuestionAnswered
   * @request PUT:/api/v1/demos/{demoId}/questions/{questionId}
   */
  questionAnswered = (
    demoId: string,
    questionId: string,
    data: ApiDemoQuestionAnswerDto,
    params: RequestParams = {},
  ) =>
    this.http.request<DemoQuestionsDto, any>({
      path: `/v1/demos/${demoId}/questions/${questionId}`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static questionAnsweredPath = '/v1/demos/${demoId}/questions/${questionId}'
  static questionAnsweredMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-demo-controller
   * @name Create9
   * @request POST:/api/v1/demos
   */
  create = (data: ApiCreateDemoDto, params: RequestParams = {}) =>
    this.http.request<DemoDto, any>({
      path: `/v1/demos`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createPath = '/v1/demos'
  static createMethod = 'POST'
  /**
   * No description
   *
   * @tags api-demo-controller
   * @name Booked1
   * @request PATCH:/api/v1/demos/{demoId}/booked
   */
  booked = (demoId: string, data: ApiDemoBookedDto, params: RequestParams = {}) =>
    this.http.request<DemoDto, any>({
      path: `/v1/demos/${demoId}/booked`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static bookedPath = '/v1/demos/${demoId}/booked'
  static bookedMethod = 'PATCH'
  /**
   * No description
   *
   * @tags api-demo-controller
   * @name GetById9
   * @request GET:/api/v1/demos/{demoId}
   */
  getById = (demoId: string, params: RequestParams = {}) =>
    this.http.request<DemoDto, any>({
      path: `/v1/demos/${demoId}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getByIdPath = '/v1/demos/${demoId}'
  static getByIdMethod = 'GET'
  /**
   * No description
   *
   * @tags api-demo-controller
   * @name GetDemoQuestions
   * @request GET:/api/v1/demos/{demoId}/questions
   */
  getDemoQuestions = (demoId: string, params: RequestParams = {}) =>
    this.http.request<DemoQuestionsDto, any>({
      path: `/v1/demos/${demoId}/questions`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getDemoQuestionsPath = '/v1/demos/${demoId}/questions'
  static getDemoQuestionsMethod = 'GET'
}
